import { EventEmitter } from '@angular/core';
import { PropertyTypes } from '../enum/propertyTypes';
import { FormProperty } from './formProperty';
import { GSCheckServeWindowRulesControl } from '../../controls/gsControls';

export class FormCheckServeWindowRulesProperty extends FormProperty {
  type = PropertyTypes.CheckServeWindowRules;
  component = GSCheckServeWindowRulesControl;
  changed = new EventEmitter<any>();

  constructor(
    name?: string,
    label?: string,
    row?: number,
    column?: number,
    rowspan?: number,
    columnspan?: number
  ) {
    super(name, label, row, column, rowspan, columnspan);
  }
}
